import { render, staticRenderFns } from "./IconDotsMore.vue?vue&type=template&id=9efda1ec&"
import script from "./IconDotsMore.vue?vue&type=script&lang=js&"
export * from "./IconDotsMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports